<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="Sheets"
                :alvqa="alvqa"
             />
            <v-col 
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="Sheets" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
            <v-spacer></v-spacer>
            <v-col 
                cols="3"
                align-self="end"
            >
                <BaseButton 
                    label="lang_PUBLISHING_SHEETS_BUTTON_CAPTION_NEW_SHEET"
                    :to="{ name: editForm, params: { alvId: 'new' } }"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import ActionDropdown from '@/components/_actions/ActionDropdown'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'

export default {
    name: "SheetsTopSlot",
    components: {
        BaseButton,
        ActionDropdown,
        BaseHeaderStats
    },
    data() {
        return {
            editForm: "SheetsEdit",
            alvqa: "publishing-sheets"
        }
    },
    computed: {
        actions() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_EXPORT'), 
                    value: 'exportSheets',
                    alvqa: this.alvqa + '-list-action-dropdown-export'
                },
                // {
                //     text: this.$t('lang_PUBLISHING_SHEETS_ACTION_CREATE_AV_REPORT'), 
                //     value: 'avReport',
                //     alvqa: this.alvqa + '-list-action-dropdown-av_report'
                // },
                {
                    text: this.$t('lang_ACCOUNT_CREDENTIALS_CAPTION_TYPE_AV_MELDUNG_API'), 
                    value: 'avGemaJson',
                    alvqa: this.alvqa + '-list-action-dropdown-av_report'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_COPY'), 
                    value: 'copy',
                    alvqa: this.alvqa + '-list-action-dropdown-copy'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_MANAGE_TAGS'), 
                    value: 'replaceTags',
                    alvqa: this.alvqa + '-list-action-dropdown-manage-tags'
                },
                { 
                    text: this.$t('lang_PUBLISHING_INCOME_ACTION_OPTION_MOVE'),
                    value: 'move', 
                    alvqa: this.alvqa + '-list-action-dropdown-move'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete',
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }                
            ]
        }
    }
}
</script>